import React from "react";
import { useEntitiesById } from "@hooks/useEntities";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: number;
}

export const RuleEntityAction: React.FC<Props> = ({ value }) => {
    const entities = useEntitiesById();
    const entity = entities.get(value);

    if (!entity) {
        return null;
    }

    return (
        <RuleTagRow
            label="Move to entity"
            type="action"
            values={[entity.name ?? "(unnamed)"]}
        />
    );
};
